export default __webpack_public_path__ + "static/media/POP_CULTURE.ef5b2862.pdf";